<template lang="html">
  <ValidationProvider slim rules="required" name="Country" v-slot="{ errors, valid }">
    <b-field
      :type="{ 'is-danger': errors[0], 'is-success': valid && displaySuccess }"
      :message="errors"
      expanded
    >
      <template slot="label">
        Country
        <b-tooltip
          position="is-right"
          type="is-dark"
          label="Country you're living in currently"
        >
          <b-icon size="is-small" icon="help-circle-outline"></b-icon>
        </b-tooltip>
      </template>
      <b-select
        placeholder="Select a country"
        v-model="selectedCountryModel"
        icon="earth"
      >
        <optgroup v-if="suggestedCountry" label="Suggested based on your location">
          <option :value="suggestedCountry.country_code">
            {{ suggestedCountry.country_name }}
          </option>
        </optgroup>
        <optgroup label="Countries">
          <option
            v-for="(country, index) in countries"
            :value="country.alpha2Code"
            :key="index"
          >
            {{ country.name }}
          </option>
        </optgroup>
      </b-select>
    </b-field>
  </ValidationProvider>
</template>

<script>
import axios from 'axios'
import { ValidationProvider } from 'vee-validate'

export default {
  props: ['selectedCountry', 'displaySuccess'],
  data () {
    return {
      countries: [],
      suggestedCountry: null
    }
  },
  components: {
    ValidationProvider
  },
  computed: {
    selectedCountryModel: {
      get () {
        return this.selectedCountry
      },
      set (value) {
        this.$emit('countrySelected', value)
      }
    }
  },
  created () {
    axios
      .get('https://restcountries.eu/rest/v1/all', {
        transformRequest: [
          (data, headers) => {
            delete headers.common.Authorization
            return data
          }
        ]
      })
      .then((res) => {
        this.countries = res.data
      })

    axios
      .get('https://freegeoip.app/json/', {
        transformRequest: [
          (data, headers) => {
            delete headers.common.Authorization
            return data
          }
        ]
      })
      .then((res) => {
        this.suggestedCountry = res.data
      })
  }
}
</script>

<style lang="scss" scoped></style>
